import { useQuery } from '@tanstack/react-query';

import { QueryParametersParticipationsUser } from '../../interfaces/scheduleInterface';
import { scheduleService } from '../../services';

export default function useQueryScheduleParticipationCSV({
	startDate,
	endDate,
	orderBy
}: QueryParametersParticipationsUser) {
	return useQuery({
		queryKey: ['Stats CSV', startDate, endDate, orderBy],
		queryFn: () => scheduleService.getScheduleParticipationCSV({ startDate, endDate, orderBy }),
		enabled: false
	});
}
